import OCVueFrameworkPlugin from './plugins/OCVueFrameworkPlugin'
import OCFlashMessagesPlugin from './plugins/OCFlashMessagesPlugin'

export default OCVueFrameworkPlugin

// HELPERS
import Form from '@/helpers/Form'
import Storage from '@/helpers/Storage'
import Errors from '@/helpers/Errors'
import Plugins from '@/helpers/Plugins'
import Counter from '@/helpers/Counter'
import EventBus from '@/helpers/EventBus'
import BaseInputComponent from '@/helpers/BaseInputComponent'
import * as Utils from '@/helpers/Utils'

import Validator from '@/helpers/validator/Validator'
import Field from '@/helpers/validator/Field'
import FieldRule from '@/helpers/validator/FieldRule'
import SchemaBuilder from '@/helpers/validator/SchemaBuilder'
import RulesParser from '@/helpers/validator/RulesParser'
import RuleValidators from '@/helpers/validator/rules'

// external
import VueScrollTo from 'vue-scrollto'
import * as validatorjs from 'validator/lib/isURL'
import Velocity from 'velocity'

export {
    // plugins
    OCFlashMessagesPlugin,

    // helpers
    Form,
    Storage,
    Errors,
    Plugins,
    Counter,
    EventBus,
    BaseInputComponent,
    Validator,
    Field,
    FieldRule,
    SchemaBuilder,
    RulesParser,
    RuleValidators,
    Utils,

    //externals
    VueScrollTo,
    validatorjs,
    Velocity
}
